import PropTypes from 'prop-types';
import Spacer from './view';

Spacer.propTypes = {
    n: PropTypes.number, // The number of gridSize spaces
};

export default Spacer;
